






































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class AiAdviceSearch extends Vue {
  private search: string = this.$store.state.aiAdviceState.searchText

  @Prop() private count!: number

  private doAiAdviceSearch () {
    this.$store.commit('aiAdviceState/setSearchText', this.search)
    this.$emit('search-list')
  }

  private doClear () {
    this.search = ''
    this.$store.commit('aiAdviceState/setSearchText', '')
    this.$emit('reset-list')
  }
}
